/**
 * References:
 *     Fabrics:
 *         [4] Baseball Polyester
 *         [27] Matrix Mesh
 *         [29] ETX
 *         [31] Performance Fleece
 *         [36] Pro Stretch Dazzle
 *         [23] LTE Fit (A00 3)
 *         [6] LTX
 *         [41] Ignite
 *
 *     Parts category:
 *         Base Material:
 *             Upper:
 *                 - Front Body
 *                 - Back Body
 *             Lower
 *                 - Base
 *
 *         Sleeve Material
 *             - Left Sleeve
 *             - Right Sleeve
 *
 *         Side Insert Material
 *             - Left Side Insert
 *             - Right Side Insert
 *
 *         Back Insert Material
 *             Upper:
 *                 - Bottom Panel
 *             Lower:
 *                 - Back Insert
 *
 *         Sleeve Insert Material
 *             -
 *
 *         Gusset Material
 *             -
 *
 *     Layer Levels:
 *         [98 - 99] - solids
 *         [100 - 101] - all mesh
 *         [102 - 103] - mixed
 */
function FabricPanel(element) {
    this.panel = document.getElementById(element);

    this.fabrics = {};

    this.setFabrics();

    FabricPanel.events.init();
}

FabricPanel.prototype = {
    constructor: FabricPanel,

    /**
     * Temporary hard coded
     *
     * @source Model Material Options.xlsx
     */
    setFabrics: function() {
        var have_base_sleeve_fabric = ub.funcs.is_pts_signature() ||
                                        ub.funcs.is_pts_pro_select() ||
                                        ub.funcs.is_pts_sleeveless() || // PTS Pro Select Sleeveless
                                        ub.funcs.is_pts_raglan() || // PTS Pro Select Raglan
                                        ub.funcs.is_pts_select() ||
                                        ub.funcs.is_select_set_in() || // PTS Select Set-In
                                        ub.funcs.is_select_sleeveless() || // PTS Select Sleeveless
                                        ub.funcs.is_pts_signature_pant() ||
                                        ub.funcs.is_pts_pro_select_pant() ||
                                        ub.funcs.is_new_pts_pant(); // PTS Pro Select Pant;
                                        ub.funcs.is_pts_select_pant() ||
                                        ub.funcs.is_select_pant() || // PTS Select Pant
                                        ub.funcs.is_pts_hoodie() ||
                                        ub.funcs.is_pts_cage_jacket();

        var have_insert_fabric = ub.funcs.is_pts_signature() ||
                                    ub.funcs.is_pts_cage_jacket() ||
                                    ub.funcs.is_pts_hoodie();

        var have_gusset_fabric = ub.funcs.is_pts_signature_pant() ||
                                ub.funcs.is_pts_pro_select_pant() ||
                                ub.funcs.is_new_pts_pant(); // PTS Pro Select Pant;

        if (have_base_sleeve_fabric) {
            this.setBaseSleeveFabrics();
        }

        if (have_insert_fabric) {
            this.setInsertFabrics();
        }

        if (have_gusset_fabric) {
            this.setGussetFabrics();
        }
    },

    setBaseSleeveFabrics: function() {
        var default_fabric = FabricPanel.getDefaultFabric();

        if (typeof default_fabric !== "undefined") {
            if (default_fabric !== null) {
                if (typeof ub.current_material.settings.current_fabric === "undefined") {
                    ub.current_material.settings.current_fabric = default_fabric.fabric.rch_alias
                }

                if (default_fabric.fabric !== "undefined") {
                    this.fabrics.base_sleeve = {data: FabricPanel.getBaseSleeveFabricSets(default_fabric)};
                    this.fabrics.base_sleeve.multiple = this.fabrics.base_sleeve.data.length > 1;
                }

                // Change assets URL
                _.map(this.fabrics.base_sleeve.data, function(item) {
                    item.thumbnail = ub.utilities.changeAssetUrl(item.thumbnail);
                });
            }
        }        
    },

    setInsertFabrics: function() {
        this.fabrics.insert = FabricPanel.getInsertFabric();
    },

    setGussetFabrics: function() {
        this.fabrics.gusset = FabricPanel.getGussetFabric();
    },

    getPanel: function() {
        var current_fabric;
        
        if (typeof this.fabrics !== "undefined") {
            if (typeof this.fabrics.base_sleeve !== "undefined") {
                var current_active = _.find(this.fabrics.base_sleeve.data, {active: "uk-active"});

                if (typeof current_active !== "undefined") {
                    if (current_active.name !== ub.current_material.settings.current_fabric) {
                        current_active.active = "";
        
                        current_fabric = _.find(this.fabrics.base_sleeve.data, {name: ub.current_material.settings.current_fabric});
                        if (typeof current_fabric !== "undefined") {
                            current_fabric.active = "uk-active";
                        }
                    }
                } else {
                    current_fabric = _.find(this.fabrics.base_sleeve.data, {name: ub.current_material.settings.current_fabric});
                    if (typeof current_fabric !== "undefined") {
                        current_fabric.active = "uk-active";
                    }
                }
            } else {
                console.warn("Cannot find fabric");
            }
        } else {
            console.warn("Missing fabrics");
        }

        ub.current_material.settings.fabric = this.fabrics;

        var panel = Mustache.render(this.panel.innerHTML, {fabrics: this.fabrics});
        return panel;
    },
};

FabricPanel.FABRIC_SOLID_IDS = [98, 99];
FabricPanel.FABRIC_ALL_MESH_IDS = [100, 101];
FabricPanel.FABRIC_MIXED_IDS = [102, 103];

FabricPanel.FRONT_PERSPECTIVE = "front";
FabricPanel.LEFT_PERSPECTIVE = "left";
FabricPanel.RIGHT_PERSPECTIVE = "right";
FabricPanel.BACK_PERSPECTIVE = "back";

FabricPanel.BASE_SLEEVE_MATERIAL = "base_sleeve";
FabricPanel.INSERT_MATERIAL = "insert";

FabricPanel.PARTS_BASE_SLEEVE = [
    // upper
    "front_body", "back_body", "left_sleeve", "right_sleeve",

    // lower
    "base"
];
FabricPanel.PARTS_SIDE_INSERT = ["left_side_insert", "right_side_insert"];
FabricPanel.PARTS_INSERT = [
    // upper
    "bottom_panel",

    // lower
    "back_insert"
];

FabricPanel.PARTS_FRONT_BODY = "front_body";
FabricPanel.PARTS_LEFT_SIDE_INSERT = "left_side_insert";

FabricPanel.events = {
    is_events_init: false,

    init: function() {
        if (!FabricPanel.events.is_events_init) {
            $('#primary_options_container').on('click', '#m-fabric-selection .con-palettes a', FabricPanel.events.onFabricLayerChange);

            FabricPanel.events.is_events_init = true;
        }
    },

    onFabricLayerChange: function() {
        var active_fabric_el = $('#m-fabric-selection .con-palettes a.uk-active');

        var layer_level = $(this).data('layer-level');
        var name = $(this).data('name');

        ub.current_material.settings.current_fabric = name;
        var active_layer_level = active_fabric_el.data('layer-level');

        var layer_levels = FabricPanel.getLayerLevels(layer_level);

        // do not change fabric if same layer level
        if (!_.include(layer_levels, active_layer_level)) {
            FabricPanel.changeFabricVisible(layer_level);
        }

        active_fabric_el.removeClass('uk-active');
        $(this).addClass('uk-active');
    }
};

FabricPanel.getDefaultFabric = function(perspective, material) {
    // default perspective
    perspective = perspective || FabricPanel.FRONT_PERSPECTIVE;
    material = material || FabricPanel.BASE_SLEEVE_MATERIAL;

    var filtered_fabric = [];

    switch(material) {
        case FabricPanel.BASE_SLEEVE_MATERIAL:
            filtered_fabric = _.filter(ub.fabric.fabricCollections[perspective], function(f) {
                return f.fabric_id !== 0 && _.include(FabricPanel.PARTS_BASE_SLEEVE, f.name);
            });

            break;

        case FabricPanel.INSERT_MATERIAL:
            filtered_fabric = _.filter(ub.fabric.fabricCollections[perspective], function(f) {
                return f.fabric_id !== 0 && (
                    _.include(FabricPanel.PARTS_SIDE_INSERT, f.name) ||
                    _.include(FabricPanel.PARTS_INSERT, f.name)
                );
            });

            break;
    }

    if (!_.isEmpty(filtered_fabric)) {
        var fabric_ids = _.uniq(_.pluck(filtered_fabric, "fabric_id"));

        if (!_.isEmpty(fabric_ids)) {
            var fabric_id = fabric_ids[0];

            if (fabric_ids.length > 1) {
                var part;

                switch(perspective) {
                    case FabricPanel.FRONT_PERSPECTIVE:
                    case FabricPanel.BACK_PERSPECTIVE:
                        part = FabricPanel.PARTS_FRONT_BODY;
                        break;

                    case FabricPanel.LEFT_PERSPECTIVE:
                    case FabricPanel.RIGHT_PERSPECTIVE:
                        part = FabricPanel.PARTS_LEFT_SIDE_INSERT;
                        break;
                }

                var fabric = _.find(filtered_fabric, {name: part});

                fabric_id = fabric.fabric_id;
            }

            return {
                fabric: _.find(ub.current_material.fabrics, {id: fabric_id.toString()}),
                layer_level: FabricPanel.getDefaultLayerLevel()
            };
        }
    }

    return null;
};

FabricPanel.getDefaultLayerLevel = function(perspective) {
    // default perspective
    perspective = perspective || FabricPanel.FRONT_PERSPECTIVE;

    var hl_sh = FabricPanel.getHighlightsAndShadows(FabricPanel.FRONT_PERSPECTIVE);

    var filtered_fabric = _.filter(hl_sh, function(fc) {
        return fc.default_asset == true || fc.default_asset == 1;
    });

    if (!_.isEmpty(filtered_fabric)) {
        var fabric = filtered_fabric.pop();

        return fabric.layer_level;
    }

    return null;
};

FabricPanel.applyDefaultLayerLevel = function() {
    var default_layer_level = FabricPanel.getDefaultLayerLevel();
    var hl_sh = FabricPanel.getHighlightsAndShadows(FabricPanel.FRONT_PERSPECTIVE);

    if (default_layer_level !== null) {
        FabricPanel.changeFabricVisible(default_layer_level);
    } else if (hl_sh !== null && !_.isEmpty(hl_sh)) {
        var first_layer_level = _.first(hl_sh).layer_level;
        FabricPanel.changeFabricVisible(first_layer_level);
    }
};

FabricPanel.getLayerLevels = function(layer_level) {
    switch (true) {
        case _.contains(FabricPanel.FABRIC_SOLID_IDS, layer_level):
            return FabricPanel.FABRIC_SOLID_IDS;

        case _.contains(FabricPanel.FABRIC_ALL_MESH_IDS, layer_level):
            return FabricPanel.FABRIC_ALL_MESH_IDS;

        case _.contains(FabricPanel.FABRIC_MIXED_IDS, layer_level):
            return FabricPanel.FABRIC_MIXED_IDS;

        default:
            return null;
    }
};

FabricPanel.getHighlightsAndShadows = function(perspective) {
    var perspectives = [
        FabricPanel.FRONT_PERSPECTIVE,
        FabricPanel.LEFT_PERSPECTIVE,
        FabricPanel.RIGHT_PERSPECTIVE,
        FabricPanel.BACK_PERSPECTIVE
    ];

    if (_.include(perspectives, perspective)) {
        return _.filter(ub.fabric.fabricCollections[perspective], function(fc) {
            return fc.name === "highlights" || fc.name === "shadows";
        });
    }

    return null;
};

FabricPanel.changeFabricVisible = function(layer_level) {
    var layer_levels = FabricPanel.getLayerLevels(layer_level);
    // hl_sh - highlights and shadows
    var front_hl_sh = FabricPanel.getHighlightsAndShadows(FabricPanel.FRONT_PERSPECTIVE);
    var left_hl_sh = FabricPanel.getHighlightsAndShadows(FabricPanel.LEFT_PERSPECTIVE);
    var right_hl_sh = FabricPanel.getHighlightsAndShadows(FabricPanel.RIGHT_PERSPECTIVE);
    var back_hl_sh = FabricPanel.getHighlightsAndShadows(FabricPanel.BACK_PERSPECTIVE);

    if (front_hl_sh !== null) {
        _.each(front_hl_sh, function (fc) {
            fc.sprite.visible = _.contains(layer_levels, fc.layer_level);
        });
    }

    if (left_hl_sh !== null) {
        _.each(left_hl_sh, function (fc) {
            fc.sprite.visible = _.contains(layer_levels, fc.layer_level);
        });
    }

    if (right_hl_sh !== null) {
        _.each(right_hl_sh, function (fc) {
            fc.sprite.visible = _.contains(layer_levels, fc.layer_level);
        });
    }

    if (back_hl_sh !== null) {
        _.each(back_hl_sh, function (fc) {
            fc.sprite.visible = _.contains(layer_levels, fc.layer_level);
        });
    }
};

// remove this function if fabric set is done
FabricPanel.getBaseSleeveFabricSets = function(default_fabric) {
    var fabric_sets = [];

    var fabric = default_fabric.fabric;
    var placeholders = ["fabric-texture.jpg", "fabric-texture-2.jpg", "fabric-texture-3.jpg"];

    var thumbnail = fabric.thumbnail || "/images/placeholder/" + placeholders[_.random(0, placeholders.length - 1)];

    fabric_sets.push({
        name: fabric.rch_alias !== null ? fabric.rch_alias : fabric.material,
        thumbnail: fabric.thumbnail !== null ? fabric.thumbnail : thumbnail,
        layer_level: default_fabric.layer_level,
        active: "uk-active",
        "description": fabric.description
    });

    var baseballPolyEster = _.find(ub.current_material.fabrics, {id: "4"});
    var matrixMesh = _.find(ub.current_material.fabrics, {id: "27"});
    var etx = _.find(ub.current_material.fabrics, {id: "29"});
    var lte = _.find(ub.current_material.fabrics, {id: "23"});
    var ltx = _.find(ub.current_material.fabrics, {id: "6"});
    var ignite = _.find(ub.current_material.fabrics, {id: "41"});

    if (ub.funcs.is_upper()) {
        switch (true) {
            case ub.funcs.is_pts_signature():
            case ub.funcs.is_pts_raglan():
            case ub.funcs.is_select_set_in():
            case ub.funcs.is_select_sleeveless():
            case ub.funcs.is_pts_sleeveless():
            case ub.funcs.is_pts_pro_select():
                if (ub.funcs.is_sublimated()) {
                    var igniteLayerLevel;

                    if (ub.funcs.is_pts_signature()) {
                        igniteLayerLevel = FabricPanel.FABRIC_MIXED_IDS[0];
                    } else if (ub.funcs.is_pts_pro_select()) {
                        igniteLayerLevel = FabricPanel.FABRIC_SOLID_IDS[0];
                    }
                    
                    if (ub.config.blockPattern === 'Select Set-In') {
                        fabric_sets.push({
                            name: ltx.rch_alias !== null ? ltx.rch_alias : ltx.material,
                            thumbnail: ltx.thumbnail !== null ? ltx.thumbnail : thumbnail,
                            layer_level: FabricPanel.FABRIC_SOLID_IDS[0], // or some other layer level
                            active: "",
                            description: ltx.description
                        });
                    }   
                    if (ub.config.blockPattern !== 'Select Set-In') {
                        fabric_sets.unshift({
                            name: ignite.rch_alias !== null ? ignite.rch_alias : ignite.material,
                            thumbnail: ignite.thumbnail !== null ? ignite.thumbnail : thumbnail,
                            layer_level: igniteLayerLevel,
                            active: "",
                            description: ignite.description
                        });
                    }
                }

                if (ub.funcs.is_twill() || ub.funcs.is_sublimated()) {
                    switch (parseInt(fabric.id)) {
                        case 4: // Baseball Polyester
                            fabric_sets.push({
                                name: matrixMesh.rch_alias !== null ? matrixMesh.rch_alias : matrixMesh.material,
                                thumbnail: matrixMesh.thumbnail !== null ? matrixMesh.thumbnail : thumbnail,
                                layer_level: FabricPanel.FABRIC_ALL_MESH_IDS[0],
                                active: "",
                                description: matrixMesh.description
                            });
                            break;

                        case 29: // ETX
                            fabric_sets.push({
                                name: matrixMesh.rch_alias !== null ? matrixMesh.rch_alias : matrixMesh.material,
                                thumbnail: matrixMesh.thumbnail !== null ? matrixMesh.thumbnail : thumbnail,
                                layer_level: FabricPanel.FABRIC_ALL_MESH_IDS[0],
                                active: "",
                                description: matrixMesh.description
                            });

                            break;

                        case 27: // matrix mesh
                            var material;
                            var layer_level;

                            if (ub.funcs.is_twill()) {
                                material = baseballPolyEster;
                            } else if (ub.funcs.is_sublimated()) {
                                material = etx;
                            }

                            if (ub.funcs.is_pts_signature()) {
                                layer_level = FabricPanel.FABRIC_MIXED_IDS[0];
                            } else if (ub.funcs.is_pts_pro_select()) {
                                layer_level = FabricPanel.FABRIC_SOLID_IDS[0];
                            }

                            fabric_sets.unshift({
                                name: material.rch_alias !== null ? material.rch_alias : material.material,
                                thumbnail: material.thumbnail !== null ? material.thumbnail : thumbnail,
                                layer_level: layer_level,
                                active: "",
                                description: material.description
                            });
                            break;
                    }
                } else {
                    ub.utilities.info("Uniform application type is not twill or sublimated");
                }

                break;

            case ub.funcs.is_pts_select():
                if (ub.funcs.is_sublimated()) {
                    switch(parseInt(fabric.id)) {
                        case 23: // LTE Fit (A00 3)
                            fabric_sets.push({
                                name: ltx.rch_alias !== null ? ltx.rch_alias : ltx.material,
                                thumbnail: ltx.thumbnail !== null ? ltx.thumbnail : thumbnail,
                                layer_level: FabricPanel.FABRIC_SOLID_IDS[0],
                                active: "",
                                description: ltx.description
                            });
                            break;

                        case 6: // LTX
                            fabric_sets.unshift({
                                name: lte.rch_alias !== null ? lte.rch_alias : lte.material,
                                thumbnail: lte.thumbnail !== null ? lte.thumbnail : thumbnail,
                                layer_level: FabricPanel.FABRIC_SOLID_IDS[0],
                                active: "",
                                description: lte.description
                            });
                            break;
                    }
                } else {
                    ub.utilities.info("Uniform application type is not sublimated");
                }

                break;
        }
    }

    if (fabric_sets.length === 1) {
        fabric_sets[0].active = "";
    }

    return fabric_sets;
};

FabricPanel.getInsertFabric = function() {
    if (ub.funcs.is_upper() && ub.funcs.is_pts_signature()) {
        return "Back and Side Panels are made from Matrix Mesh";
    } else if (ub.funcs.is_lower() && ub.funcs.is_pts_signature()) {
        return "Back Panel is made from Matrix Mesh";
    } else if (ub.funcs.is_pts_cage_jacket()) {
        return "Side and Sleeve Panels are made from Matrix Mesh";
    }

    return null;
};

FabricPanel.getGussetFabric = function() {
    if (ub.funcs.is_lower() && (ub.funcs.is_pts_signature() || ub.funcs.is_pts_pro_select() || ub.funcs.is_new_pts_pant())) {
        return "Gusset Panel is made from Matrix Mesh";
    }

    return null;
};

FabricPanel.prepareFabricPayload = function() {
    var gusset = "";
    var insert = ""; 
    
    if (typeof ub.current_material.settings.fabric !== "undefined") {
        gusset = typeof ub.current_material.settings.fabric.gusset !== "undefined" ? ub.current_material.settings.fabric.gusset : "";
        insert = typeof ub.current_material.settings.fabric.insert !== "undefined" ? ub.current_material.settings.fabric.insert : "";
    }

    var current_fabric = ub.current_material.settings.current_fabric;
    // I will hardcode the FLX fabric for PTS Hoodie Insert
    if (ub.funcs.is_pts_hoodie()) {
        insert = "FLX";
    }

    ub.config.description.fabricData = {
        fabric: typeof current_fabric !== "undefined" ? current_fabric : "N/A",
        details: {
            gusset: gusset,
            insert: insert
        }
    };
}